import { z } from 'zod';

import { locationSchema } from './location';
import { userRoleSchema } from './user-role';
import { regionSchema } from './region';
import { companySchema } from './company';

/** User schema. */
export const userSchema = z
	.object({
		id: z.number(),
		email: z.string(),
		fullName: z.string(),
		location: locationSchema.nullable(),
		defaultTermId: z.number().nullable(),
		defaultLogo: z.string().nullable(),
		includeCustomerEquipment: z.boolean(),
		role: userRoleSchema.nullable(),
		profilePicture: z.string(),
		company: companySchema.nullable(),
		isMasquerading: z.boolean(),
	});

/** User configuration schema. */
export const userConfigurationSchema = userSchema.pick({
	defaultLogo: true,
	defaultTermId: true,
	includeCustomerEquipment: true,
});

/** User edit schema. */
export const userEditSchema = userSchema.pick({
	fullName: true,
	email: true,
}).extend({
	roleId: userRoleSchema.shape.id,
	locationId: regionSchema.shape.id,
	profilePicture: z.instanceof(File).nullable(),
});

/** Basic representation of a user. */
export type User = Readonly<z.infer<typeof userSchema>>;

/** User configuration. */
export type UserConfiguration = Readonly<z.infer<typeof userConfigurationSchema>>;

/** User edit schema. */
export type UserEdit = Readonly<z.infer<typeof userEditSchema>>;
